export const FETCH_MESSAGING_ACCOUNTS = 'MESSAGING_ACCOUNTS/FETCH_REQUEST';
export const FETCH_MESSAGING_ACCOUNTS_SUCCESS = 'MESSAGING_ACCOUNTS/FETCH_SUCCESS';

export const FETCH_AVAILABLE_MESSAGING_ACCOUNTS = 'MESSAGING_ACCOUNTS/FETCH_AVAILABLE_REQUEST';
export const FETCH_AVAILABLE_MESSAGING_ACCOUNTS_SUCCESS = 'MESSAGING_ACCOUNTS/FETCH_AVAILABLE_SUCCESS';

export const FETCH_MESSAGING_ACCOUNT = 'MESSAGING_ACCOUNT/FETCH_REQUEST';
export const FETCH_MESSAGING_ACCOUNT_SUCCESS = 'MESSAGING_ACCOUNT/FETCH_SUCCESS';

export const CREATE_MESSAGING_ACCOUNT = 'MESSAGING_ACCOUNT/POST_REQUEST';
export const CREATE_MESSAGING_ACCOUNT_SUCCESS = 'MESSAGING_ACCOUNT/POST_SUCCESS';

export const UPDATE_MESSAGING_ACCOUNT = 'MESSAGING_ACCOUNT/PUT_REQUEST';
export const UPDATE_MESSAGING_ACCOUNT_SUCCESS = 'MESSAGING_ACCOUNT/PUT_SUCCESS';

export const DELETE_MESSAGING_ACCOUNT = 'MESSAGING_ACCOUNT/DELETE_REQUEST';
export const DELETE_MESSAGING_ACCOUNT_SUCCESS = 'MESSAGING_ACCOUNT/DELETE_SUCCESS';
export const DELETE_MESSAGING_ACCOUNT_FAILURE = 'MESSAGING_ACCOUNT/DELETE_FAILURE';

export const SET_DASHBOARD_FILTER = 'MESSAGING_ACCOUNTS/DASHBOARD/FILTERS/SET_ONE';
export const CLEAR_DASHBOARD_FILTERS = 'MESSAGING_ACCOUNTS/DASHBOARD/FILTERS/CLEAR';

export const OPEN_MODAL = 'MESSAGING_ACCOUNTS/MODAL/OPEN';
export const CLOSE_MODAL = 'MESSAGING_ACCOUNTS/MODAL/CLOSE';
